import React, { useEffect, useState }from 'react';
import Card from '../../components/card.component';
import {
  Row,
  Col
} from 'react-bootstrap';
import { useForm } from "react-hook-form";
import sucursalFunction from './sucursal.functions';
import table from './sucursal.table';
import notification from '../../components/notification.component';
import DataTable from 'react-data-table-component';
import { useHistory } from 'react-router-dom';

const Sucursal = () => {

  const history = useHistory();
  const [modo, setModo] = useState('I');
  const [idMod, setModId] = useState(0);
  const [listado, setListado] = useState([]);
  const { register, handleSubmit, reset, errors } = useForm();
  const onSubmit = data => {
    if (modo === 'I') { 
      sucursalFunction.registro(data).then((response) => {
      if (response.data.registro_sucursal) {
        notification.success();
        reset();
        listadoApi();
      } else {
        notification.warning('Ocurrio un error intentelo nuevamente');
      }
      })
    } else {
      sucursalFunction.modificar({...data, id: idMod}).then((response) => {
        if (response.data.modifica_sucursal) {
          listadoApi();
          notification.success();
          reset({
            description:'',
            address: '',
          });
          setModId(0);
          setModo('I');
        } else {
          notification.warning('Ocurrio un error intentelo nuevamente');
        }
        })
    }
  }

  const listadoApi = () => {
    sucursalFunction.listado().then((response) => {
      setListado(response.data);
    })
  }

  const selectionClient = (row) => {
    reset(row);
    setModId(row.id);
    setModo('M');
  }

  const cancelOperation = () => {
    reset({});
    setModo('I');
  }

  const goConfig = (uuid) => {
    history.replace(`/sucursal/${uuid}`)
  }

  useEffect(() => {
    listadoApi();
  },[])

  return (
  <>
    <Row>
      <Col lg={6}>
        <Card>
          <Row>
            <Col>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="grupo-input">
                  <small>Nombre sucursal</small>
                  <input type="text" className={`form-control input-border ${errors.description && "is-invalid"}`} name="description" ref={register({ required: true })} />
                </div>
                <div className="grupo-input">
                  <small>Dirección</small>
                  <input type="text" className={`form-control input-border ${errors.address && "is-invalid"}`} name="address" ref={register({ required: true })} />
                </div>
                <div className="grupo-input mt-2">
                    { modo === 'I' ? 
                      <button type="submit" className="btnx btnx-warn">Registrar</button> 
                      : 
                      <button type="submit" className="btnx btnx-warn">Modificar</button>
                    }
                    {' '}<button onClick={cancelOperation} type="button" className="btnx btnx-warn">Cancelar</button>
                </div>
              </form>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
    <Row className="mt-3">
    <Col lg={12}>
     <Card>
      <Row>
        <Col>
           <DataTable
            title="Sucursales"
            customStyles={table.customStyles}
            columns={table.colummnsWithFunc(selectionClient, () => console.log('a'), goConfig)}
            data={listado}
            dense={true}
            pagination={true}
        /> 
        </Col>
       </Row>
      </Card>
     </Col>
    </Row>
    </>
  )
}

export default Sucursal;